const Cleat3 = ({ ...props }) => {
  return (
    <svg
      width="18.52387"
      height="17.00017"
      viewBox="0 0 18.52387 15.111262"
      // fill="none"
      stroke="currentColor"
      {...props}
    >
      <circle
        cx="9.2618198"
        cy="2.92857"
        r="3.42857"
        id="circle2"
        fill={props.fill}
      />
      <circle
        cx="14.5953"
        cy="12.0716"
        r="3.42857"
        id="circle4"
        fill={props.fill}
      />
      <circle
        cx="3.92857"
        cy="12.0716"
        r="3.42857"
        id="circle6"
        fill={props.fill}
      />
    </svg>
  )
}

export default Cleat3
